export enum EventItemType {
    FINISHED = "finished",
    UPCOMING = "upcoming",
}